import { useState } from "react";
import { replaceUnderscore } from "../../../CommonFunction/common";
import Button from "../../Components/Button/Button";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import Input from "../../Components/Input/Input";
import "./AccountingChecksPage.scss";
import AccountChecks from "./ChecksPages/AccountChecks";
import BalanceVsMonthlySummary from "./ChecksPages/BalanceVsMonthlySummary";
import BalanceVsOpenRefsPanel from "./ChecksPages/BalanceVsOpenRefsPanel";
import BalanceVsTransactionsView from "./ChecksPages/BalanceVsTransactionsView";
import TransactionsDebitCreditMatcher from "./ChecksPages/TransactionsDebitCreditMatcher";
import CompanyTransactionsView from "./ChecksPages/CompanyTransactionsView";

const dropdownComponents = {
  "Monthly Balance vs Calculate monthly balances": <AccountChecks />,
  "Transactions (Debit/Credit Match)": <TransactionsDebitCreditMatcher />,
  "Account Balance vs. Monthly Summaries": <BalanceVsMonthlySummary />,
  "Account Balance vs. Open References": <BalanceVsOpenRefsPanel />,
  "Account Balance vs. Individual Transactions": <BalanceVsTransactionsView />,
  "Transaction History": <CompanyTransactionsView />,
};

const AccountingChecksPage = () => {
  const [selectedValue, setSelectedValue] = useState("");
  const [activeComponentKey, setActiveComponentKey] = useState("");
  const Key = "Accounting_Checks_Page";

  const handleChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const handleGo = () => {
    if (dropdownComponents[selectedValue]) {
      setActiveComponentKey(selectedValue);
    } else {
      setActiveComponentKey("");
    }
  };

  return (
    <div>
      <div className="Page_Title_Container_For_Accounting">{replaceUnderscore("Accounting Checks Section")}</div>
      <div className="Accounting_Check_Search_Box_Container">
        <div className="Accounting_Check_Search_Box">
          <Input
            EMTQuery=""
            checked=""
            InputConfig={{}}
            type="Dropdown"
            name="Accounting_Check"
            dropdowndata={Object.keys(dropdownComponents)}
            handleBlur={() => {}}
            handleInputChange={(e) => handleChange(e)}
            label={"Select accounting check"}
            modalform={true}
            Iconinside={true}
            value={selectedValue}
          />
        </div>
        <div>
          <Button name="gobutton" text="GO" action={handleGo}></Button>
        </div>
        <div className="Header_With_Input">
          <HeaderDiv
            TableKey={Key}
            MoreActions={{
              Is_Forword: false,
              Is_Add: false,
              Is_View: false,
              Is_Delete: false,
              Is_Edit: false,
              Is_Print: false,
            }}
          />
        </div>
      </div>

      <div>{activeComponentKey && dropdownComponents[activeComponentKey]}</div>
    </div>
  );
};

export default AccountingChecksPage;
